import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, message, Input, Form, Spin, Card, Tag } from 'antd';
import { ConsoleSqlOutlined, DeleteOutlined } from '@ant-design/icons';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const UpdateRecordFlowDrawer = ({isEditingMode,selectedNode, visible, onClose, nodeData, onSave,setNodeData }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [filters, setFilters] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [fieldValues, setFieldValues] = useState({}); // New state to track values of selected fields
  const [logic, setLogic] = useState('');
  const [operator, setOperator] = useState('AND');
  const [valueOperator, setValueOperator] = useState('');
  
  useEffect(() => {
    if (visible) {
      fetchObjects();
    }
  }, [visible]);

  useEffect(() => {
    if (nodeData && Object.keys(nodeData).length > 0) {
      // Set basic details
      setName(nodeData.name || '');
      setApiName(nodeData.apiname || '');
      setDescription(nodeData.description || '');
      setSelectedObject(nodeData.parameters?.model || null);
  
      // Set logic
      setLogic(nodeData.parameters?.logic_string || '');
  
      // Set conditions (filters)
      const existingFilters = nodeData.parameters?.conditions
        ? Object.entries(nodeData.parameters?.conditions).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';
          if (Object.keys(value)[0] !== "0") {
            operator = Object.keys(value)[0];
            actualValue = value[operator];
          } else {
            actualValue = value; // Extract the actual value (e.g., '50')
          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
      setFilters(existingFilters); // Set filters state here
      // const filters = nodeData.parameters?.conditions
      //   ? Object.keys(nodeData.parameters.conditions).map((key) => ({
      //       id: key,
      //       field: nodeData.parameters.conditions[key]?.field || '',
      //       value: nodeData.parameters.conditions[key]?.value || '',
      //     }))
      //   : [];
      // setFilters(filters);
  
      // Set updates
      // const updates = nodeData.parameters?.updates
      //   ? Object.keys(nodeData.parameters.updates).map((key) => {
      //       const update = nodeData.parameters.updates[key];
      //       return {
      //         field: update?.field || key,
      //         value: update?.value || '',
      //       };
      //     })
      //   : [];
      setFieldValues(nodeData.parameters?.updates);
      setSelectedFields(Object.keys(nodeData.parameters?.updates));
      // console.log('setfieldvalues:',updates);
      // Reset operator (assuming no operator field in your new structure)
      setOperator('AND');
  
      // Fetch fields for the selected object if available
      if (nodeData.parameters?.model) {
        fetchFields(nodeData.parameters.model);
      }
    }
    // else if (nodeData && Object.keys(nodeData).length > 0) {
    //   // Set basic details
    //   setName(nodeData.name || '');
    //   setApiName(nodeData.apiName || '');
    //   setDescription(nodeData.description || '');
    //   setSelectedObject(nodeData.selectedObject || null);
    
    //   // Set logic
    //   setLogic(nodeData.logic || '');
    
    //   // Set conditions (filters)
    //   console.log('udpate:: ',nodeData.filterObj);
    //   const existingFilters = nodeData.filterObj
    //   ? Object.entries(nodeData.filterObj).map(([key, { field, value }]) => {
    //     let operator = '';
    //     let actualValue = '';
    //     if (Object.keys(value)[0] !== "0") {
    //       operator = Object.keys(value)[0];
    //       actualValue = value[operator];
    //     } else {
    //       actualValue = value; // Extract the actual value (e.g., '50')
    //     }
    //     let op = '';
    //     if (operator !== '') {
    //       try {
    //         setValueOperator(operator.replace('$', ''));
    //         op = operator.replace('$', '');
    //       } catch (error) {
    //         // Handle the error gracefully
    //         setValueOperator(''); // or any default value
    //       }
    //     } else {
    //       op = '';
    //     }
    //     return {
    //       field,
    //       value: value,
    //       displayValue: actualValue,
    //       operator: op
    //     };
    //   })
    //   : [{ field: '', value: '', operator: '' }];
    //   setFilters(existingFilters); // Set filters state here
    //   setFieldValues(nodeData.fieldValues);
    //   console.log('setfieldvalues:',nodeData.fieldValues);
    
    //   // Set selected fields
    //   setSelectedFields(nodeData.selectedFields || []);
    //   console.log(nodeData.selectedFields);
    //   // Fetch fields for the selected object if available
    //   if (nodeData.selectedObject) {
    //     fetchFields(nodeData.selectedObject);
    //   }
    // }
    else {
      // Reset all states if nodeData is empty or null
      setName('');
      setApiName('');
      setDescription('');
      setSelectedObject(null);
      setFieldValues([]);
      setLogic('');
      setFilters([]);
      setOperator('AND');
    }
  }, [nodeData]);
  

  const fetchObjects = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setObjects(response);
    } catch (error) {
      console.error('Error fetching objects:', error);
      message.error('Failed to fetch objects.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
      message.error('Failed to fetch fields.');
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    fetchFields(value);
    setSelectedFields([]); // Clear previously selected fields
    setFieldValues({}); // Reset field values
  };

  const handleFieldSelect = (field) => {
    if (!selectedFields.includes(field)) {
      setSelectedFields([...selectedFields, field]);
      setFieldValues({ ...fieldValues, [field]: '' }); // Initialize the value for the field
    }
  };

  const handleFieldValueChange = (field, value) => {
    setFieldValues({ ...fieldValues, [field]: value }); // Update the value for the selected field
  };

  const handleRemoveField = (field) => {
    setSelectedFields(selectedFields.filter((f) => f !== field));
    const { [field]: removed, ...rest } = fieldValues; // Remove the value associated with the field
    setFieldValues(rest);
  };

  const handleSave = () => {
    if (!name || !apiName || !selectedObject || selectedFields.length === 0) {
      message.error('Please fill all required fields.');
      return;
    }
    
    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.value
        }; 
      }
      return acc;
    }, {});

    const type = "Update Records";
    const data = {
      name,
      apiName,
      description,
      selectedObject,
      filterObj,
      logic,
      selectedFields,
      fieldValues, // Include field values in the saved data
      type
    };

    onSave(selectedNode.id,data); // Pass the data to the parent component
    message.success('Update Record saved successfully!');
    setNodeData([]);
    onClose();
  };
const handleCancel = ()=>{
  setNodeData([]);
  onClose();
}
  const filteredFields = fields.filter((field) => !selectedFields.includes(field.name));

  return (
    <Drawer
      title={`Update Records`}
      placement="right"
      onClose={handleCancel}
      visible={visible}
      width={600}
      zIndex={1002}   // higher than sidebar
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="default" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      footerStyle={{ textAlign: 'right' }}
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <Form layout="vertical">
          <Form.Item label="Name" required>
            <Input
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => {
                if (name) {
                  setApiName(
                    name
                      .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                      .replace(/\s+/g, "") // Remove spaces
                      .trim()
                  );
                }
              }}          
            />
          </Form.Item>

          <Form.Item label="API Name" required>
            <Input
              placeholder="Enter API name"
              value={apiName}
              onChange={(e) => setApiName(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              placeholder="Enter description"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Select Object" required>
            <Select
              placeholder="Select Object"
              style={{ width: '100%' }}
              onChange={handleObjectChange}
              value={selectedObject}
            >
              {objects.map((obj) => (
                <Option key={obj.name} value={obj.name}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {selectedObject && (
            <FiltersDynamic
              fields={fields}
              filters={filters}
              setFilters={setFilters}
              logic={logic}
              setLogic={setLogic}
              setValueOperator={setValueOperator}
              valueOperator={valueOperator}
              // fetchLookupRecords={() => {}}
              // fetchLookupRecordsForExistingFilters={() => {}}
            />
          )}

          {selectedObject && (
            <Card style={{ marginTop: 20 }}>
              <Form.Item label="Select Fields for Update">
                <Select
                  mode="multiple"
                  placeholder="Select fields to update"
                  onSelect={handleFieldSelect}
                  value={selectedFields}
                  style={{ width: '100%' }}
                >
                  {filteredFields.map((field) => (
                    <Option key={field.name} value={field.name}>
                      {field.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              {/* Render selected fields and input fields */}
              {selectedFields.length > 0 && (
                <div>
                  {selectedFields.map((field) => (
                    <div key={field} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                      <Tag>{field}</Tag>
                      <Input
                        style={{ marginLeft: '10px', flex: 1 }}
                        placeholder={`Enter value for ${field}`}
                        value={fieldValues[field]}
                        onChange={(e) => handleFieldValueChange(field, e.target.value)}
                      />
                      <Button
                        danger
                        style={{ marginLeft: '10px' }}
                        onClick={() => handleRemoveField(field)}
                        icon={<DeleteOutlined />}
                      >
                        {/* Remove */}
                      </Button>
                    </div>
                  ))}
                </div>
              )}
            </Card>
          )}
        </Form>
      )}
    </Drawer>
  );
};

export default UpdateRecordFlowDrawer;
